export default "__VITE_ASSET__luznA1q8__"